import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { Postcode, PostcodeStatus } from 'src/app/interfaces/postcode';

@Component({
  selector: 'app-missing-pets',
  templateUrl: './missing-pets.component.html',
  styleUrls: ['./missing-pets.component.scss']
})
export class MissingPetsComponent implements OnInit {
  loading = false;
  missingPets: Array<any> = [];
  postcode: Postcode = {
    name: null,
    lat: null,
    lng: null,
    status: PostcodeStatus.Invalid,
  };
  searchFilters = {
    species: null,
    location: null,
    status: null,
  };

  constructor(private route: ActivatedRoute) {
    this.missingPets = route.snapshot.data.pets;
  }

  /**
   *
   * @description Only console logs for now. When other filters are complete
   * this will retrieve an array of missing pets matching the search criteria
   */
  search(): void {
    // TODO: Combine search params with other filters, then call endpoint to filter the results
    this.searchFilters.location = {
      name: this.postcode.name,
      lat: this.postcode.lat,
      lng: this.postcode.lng,
      status: this.postcode.status,
    };
    console.log('Search for: ', this.searchFilters);
  }

  ngOnInit(): void {}
}
